import { BaseDeckManagementEntry, createChangeSetOperations, nullableString } from '@schema/Common.schema.ts';
import { z } from 'zod';

/**
 * Footnote Schema for SaveDeck operations
 */
export const FootnoteSchema = BaseDeckManagementEntry.extend({
  footnote_id: z.string(),
  page_id: z.string(),
  footnote_no: nullableString,
  footnote_description: z.string(),
});

export const CreateFootnoteSchema = FootnoteSchema.omit({
  pk: true,
  sk: true,
});

export const UpdateFootnoteSchema = FootnoteSchema.omit({
  pk: true,
  sk: true,
});

export const DeleteFootnoteSchema = z.object({
  page_id: z.string(),
  footnote_id: z.string(),
});

export const FootnoteChangeSetSchema = createChangeSetOperations({
  create: CreateFootnoteSchema,
  update: UpdateFootnoteSchema,
  delete: DeleteFootnoteSchema,
});

export type FootnoteChangeSetType = z.infer<typeof FootnoteChangeSetSchema>;
